import { useFormContext } from "react-hook-form";
import { Trans } from "react-i18next";
import { InvoiceFromOcrDto } from "@/api/invoiceApi";
import { InvoiceFormData } from "@/types";
import { Alert, BodyShort } from "@digital-services-gard-as/anchor-react";

type ClaimRefBannerProps = {
    ocrResponse?: InvoiceFromOcrDto;
};
export const ClaimRefBanner = ({ ocrResponse }: ClaimRefBannerProps) => {
    const { watch } = useFormContext<InvoiceFormData>();
    const selectedClaimRef = watch("claimRef");

    const ocrClaimRef =
        ocrResponse?.claimsRef ?? (ocrResponse?.subClaimsRef ? ocrResponse.subClaimsRef.split("-")[0] : undefined);

    const isEqualClaimRef = ocrClaimRef === selectedClaimRef?.replaceAll(/\s+/g, "");

    if (!ocrClaimRef || isEqualClaimRef || !selectedClaimRef) {
        return null;
    }
    return (
        <Alert variant="warning" contentMaxWidth={false}>
            <BodyShort>
                <Trans i18nKey="invoices:createInvoice.claimRefNoMatch" values={{ ocrClaimRef }} />
            </BodyShort>
        </Alert>
    );
};
